/** @file Auto-rig panel registration (spec §9): import, one action per analysis, review, apply, undo. */
import type { PanelEntry } from '../panelEntry';
import { AutorigPanel } from './AutorigPanel';

/** Not a canvas panel: a hidden tab may unmount, which closes its session and clears its ghost. */
export const panel: PanelEntry = { id: 'autorig', title: 'autorig.title', bindings: [], component: AutorigPanel };
